import { render, staticRenderFns } from "./GClassManagementTrendAnalysisHumanitiesOrSciences.vue?vue&type=template&id=17897acf&scoped=true&"
import script from "./GClassManagementTrendAnalysisHumanitiesOrSciences.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementTrendAnalysisHumanitiesOrSciences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17897acf",
  null
  
)

export default component.exports